import {ServiceContent} from "../"

export class ServiceContentResponseItem extends Array<ServiceContent> {
    constructor(serviceContentArr: Array<ServiceContent>) {
        super()
        serviceContentArr.forEach((item: ServiceContent) => {
            this.push(item)
        })
    }
}

